module.exports = __webpack_public_path__ + "static/media/profile.278a0d25.jpg";